(() => {
  const initialise = (root) => {
    if (root.dataset.brandPartnersReady === 'true') return;

    const track = root.querySelector('[data-brand-partner-track]');
    if (!track) return;

    root.dataset.brandPartnersReady = 'true';
    root.querySelectorAll('[data-brand-partner-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.brandPartnerDirection === 'previous' ? -1 : 1;
        const distance = Math.min(track.clientWidth * 0.82, 900);
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      });
    });
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-brand-partners]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
